import { rhythm } from 'Themes/typography';
import styled from 'styled-components';

const Footer = styled.div`
  padding: ${rhythm(1)} ${rhythm(2.5)};
  border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
`;

export default Footer;
